import { systemEngineEnvironment } from "services/environment/systemEngine";

export const deleteEngineMutation = async (name: string) => {
  return systemEngineEnvironment.execute(`DROP ENGINE IF EXISTS "${name}"`);
};
